import React, { useState } from "react";
import TabItem from "./TabItem";
import TabsDropdown from "./TabsDropdown";

export type TabType = "overview" | "schedule" | "accommodation" | "tora";

interface TabsContainerProps {
  activeTab: TabType;
  handleTabChange: (tab: TabType) => void;
}

const TabsContainer: React.FC<TabsContainerProps> = ({
  activeTab,
  handleTabChange,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const tabOptions = [
    {
      value: "overview",
      label: "Overview",
      icon: "fa-signs-post",
    },
    {
      value: "schedule",
      label: "Schedule",
      icon: "fa-calendar-days",
    },
    {
      value: "accommodation",
      label: "Accommodation",
      icon: "fa-house",
    },
    {
      value: "tora",
      label: "Plan with Tora",
      mobileLabel: "Tora",
      icon: "fa-sparkles",
    },
  ];

  return (
    <div className="itinerary-button-menu flex flex-row items-center w-full mt-1.5">
      {/* Mobile Dropdown (visible below lg) */}
      <TabsDropdown
        activeTab={activeTab}
        isOpen={isDropdownOpen}
        toggleDropdown={() => setIsDropdownOpen(!isDropdownOpen)}
        handleTabChange={handleTabChange}
        options={tabOptions}
      />

      {/* Desktop Buttons (visible lg and above) */}
      <div className="hidden lg:flex flex-row items-center space-x-2.5">
        {tabOptions.map((tab) => (
          <TabItem
            key={tab.value}
            label={tab.label}
            icon={tab.icon}
            isActive={activeTab === tab.value}
            onClick={() => handleTabChange(tab.value as TabType)}
            displayName={
              tab.value === "tora" ? (
                <React.Fragment>
                  <h2 className="text-[14px] 2xl:text-[15px] tracking-wide xl:block hidden">
                    Plan with Tora
                  </h2>
                  <h2 className="text-[14px] 2xl:text-[15px] tracking-wide xl:hidden">
                    Tora
                  </h2>
                </React.Fragment>
              ) : undefined
            }
          />
        ))}
      </div>
    </div>
  );
};

export default TabsContainer;
